"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityBlockType = void 0;
var FacilityBlockType;
(function (FacilityBlockType) {
    FacilityBlockType["COUNTY_BLOCK"] = "County Block";
    FacilityBlockType["AUDIO_CALL_BLOCK"] = "Audio Call Block";
    FacilityBlockType["VIDEO_CALL_BLOCK"] = "Video Call Block";
    FacilityBlockType["VOICEMAIL_BLOCK"] = "Voicemail Block";
    FacilityBlockType["TEXTING_BLOCK"] = "Texting Block";
    FacilityBlockType["TEXTING_IMAGE_BLOCK"] = "Texting Image Block";
})(FacilityBlockType = exports.FacilityBlockType || (exports.FacilityBlockType = {}));
